import { Controller } from "@hotwired/stimulus"

// Shows pending sync count badge and spinner in operator nav.
export default class extends Controller {
  static targets = ["spinner", "badge", "count"]

  connect() {
    this.syncCompleteHandler = (event) => this.handleSyncComplete(event)
    this.syncErrorHandler = () => this.handleSyncError()

    document.addEventListener("sync:complete", this.syncCompleteHandler)
    document.addEventListener("sync:error", this.syncErrorHandler)

    // Periodically check pending count
    this.updateBadge()
    this.interval = setInterval(() => this.updateBadge(), 30000)
  }

  disconnect() {
    document.removeEventListener("sync:complete", this.syncCompleteHandler)
    document.removeEventListener("sync:error", this.syncErrorHandler)
    if (this.interval) clearInterval(this.interval)
  }

  handleSyncComplete(event) {
    this.hideSpinner()
    const detail = event.detail || {}
    if (detail.synced > 0) {
      document.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: `Synced ${detail.synced} item(s)`, type: "success" }
      }))
    }
    this.updateBadge()
  }

  handleSyncError() {
    this.hideSpinner()
    document.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message: "Sync failed — will retry", type: "error" }
    }))
  }

  showSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
  }

  async updateBadge() {
    try {
      if (!("indexedDB" in window)) return

      const count = await this.getPendingCount()
      if (this.hasBadgeTarget && this.hasCountTarget) {
        if (count > 0) {
          this.countTarget.textContent = count > 99 ? "99+" : count
          this.badgeTarget.classList.remove("hidden")
        } else {
          this.badgeTarget.classList.add("hidden")
        }
      }
    } catch {
      // IndexedDB not available
    }
  }

  getPendingCount() {
    return new Promise((resolve) => {
      try {
        const request = indexedDB.open("logix_offline", 1)
        request.onsuccess = () => {
          const db = request.result
          if (!db.objectStoreNames.contains("pending_sync")) {
            resolve(0)
            return
          }
          const tx = db.transaction("pending_sync", "readonly")
          const store = tx.objectStore("pending_sync")
          const index = store.index("status")
          const countReq = index.count(IDBKeyRange.only("pending"))
          countReq.onsuccess = () => resolve(countReq.result)
          countReq.onerror = () => resolve(0)
        }
        request.onerror = () => resolve(0)
      } catch {
        resolve(0)
      }
    })
  }
}
